import { useMemo } from 'react'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  return useMemo(() => {
    if (!data) return data

    return {
      ...data,
      tasks_tasks: data.tasks_tasks.map(item => ({
        ...item,
        priority:
          (item.priority &&
            item.priority.charAt(0).toUpperCase() + item.priority.slice(1)) ||
          null,
        patient: item.patients?.[0],
        assignee: item.assignees?.[0],
      })),
    }
  }, [data])
}
